import { CheckIcon } from "../../assets/icons";

export interface LoanCalculatorTagsProps {
  tags?: string[];
  className?: string;
  pillClassName?: string;
  showIcon?: boolean;
}

export const Tags: React.FC<LoanCalculatorTagsProps> = ({
  tags = [],
  className = "",
  pillClassName = "",
  showIcon = true,
}) => {
  if (!tags.length) return null;
  return (
    <div
      className={`cx-mt-2 cx-flex cx-flex-row cx-flex-wrap cx-gap-2 cx-justify-center cx-items-center ${className}`}
    >
      {tags.map((tag) => (
        <div
          key={tag}
          className={`cx-text-xs cx-bg-background-default cx-border cx-border-border-default cx-rounded-full cx-px-3 cx-py-1 cx-text-text-secondary cx-flex cx-items-center cx-gap-1.5 ${pillClassName}`}
        >
          {showIcon && (
            <CheckIcon className="cx-w-3.5 cx-h-3.5 cx-text-success cx-flex-shrink-0" />
          )}
          <span className="cx-leading-none">{tag}</span>
        </div>
      ))}
    </div>
  );
};
